(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["a11y-judgeme"] && !Shopify.designMode) return;
  try {
    (function () {
  function labelArrows(root) {
    var arrows = (root || document).querySelectorAll('.jdgm-arrow:not([aria-label])');
    for (var i = 0; i < arrows.length; i++) {
      var btn = arrows[i];
      var action = btn.getAttribute('onclick') || '';
      var isPrev = /[Pp]revious/.test(action) || btn.className.indexOf('prev') !== -1;
      btn.setAttribute('aria-label', isPrev ? 'Recensione precedente' : 'Recensione successiva');
      if (!btn.getAttribute('type')) {
        btn.setAttribute('type', 'button');
      }
    }
  }

  function init() {
    labelArrows(document);
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
          labelArrows(document);
          break;
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
